export default __webpack_public_path__ + "static/media/Crt2.781ad876.png";